import React, { useEffect, useState } from "react";
import "./Landing.css";
import heroBg from '../assets/hero-bg.png';
import mobileHeroBg from '../assets/Gemini_Generated_Image_6imh1f6imh1f6imh (1).png';
import characterImg from '../assets/charactermob.png';
import webCharacterImg from '../assets/asd-removebg-preview.png';
import eventsBg from '../assets/events-bg.png';
import cardFrame from '../assets/tfk7cwfk6qk8ehihnyxx.jpeg';
import sponsor1 from '../assets/compressed/sponsor1.png';
import sponsor2 from '../assets/compressed/sponsor2.jpg';
import sponsor3 from '../assets/compressed/sponsor3.png';
import image1 from '../assets/compressed/IMAGE1.jpg';


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from 'framer-motion';
import { ReactTyped } from "react-typed";

import { Link } from 'react-router-dom';
import CountDownTimer from './Countdowntimer.js';  // adjust the path based on your file structure





import Slider from "react-slick";




const Landing = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const scrollHandler = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);
  

  return (
    <div className="landing-page">

<div className="landing-content">
  {/* Desktop/Tablet Landing Section */}
  <section id="landing" className="desktop-landing" style={{ position: 'relative', overflow: 'visible' }}>
    {/* Top Half with Image and Black Overlay */}
    <div
      className="landing-top"
      style={{
        minHeight: '100vh',
        paddingTop: '72px',
        backgroundColor: '#0b1420',
        backgroundImage: `url(${heroBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
        filter: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingLeft: '5%',
        color: 'white',
        textAlign: 'left',
      }}
    >
      <div className="hero-copy-wrap d-flex align-items-center justify-content-center">
        <div className="text-center" style={{ paddingLeft: '3rem' }}>
          <motion.div
            initial={{ y: '-100vh' }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.9 }}
          >
            <h1 className="fw-bold display-1 mb-2 arcane-gold" style={{ letterSpacing: '6px', fontFamily: "'Cinzel Decorative', serif" }}>ROBOCOR '26</h1>
            <h4 className="fw-semibold mb-4 arcane-gold" style={{ letterSpacing: '3px' }}>
              <span style={{ fontSize: '1em', fontWeight: 'inherit' }}>"</span>
              In Steel we Forge, In Hex we Rise.
              <span style={{ fontSize: '1em', fontWeight: 'inherit' }}>"</span>
            </h4>
          </motion.div>
          <motion.div
            initial={{ x: '-100vw' }}
            animate={{ x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="hero-date-wrap"
          >
            <ReactTyped
              strings={["April 16th"]}
              typeSpeed={80}
              backSpeed={40}
              loop
              className="hero-date-text"
            />
          </motion.div>
          <CountDownTimer targetDate={new Date("2026-04-16T00:00:00")} className="countdown" />
        </div>
      </div>

      {/* Floating Hero Character */}
      <img
        src={webCharacterImg}
        alt="Hero Character"
        style={{
          position: 'absolute',
          bottom: '-280px',
          right: '4%',
          width: '480px',
          zIndex: 2,
          filter: 'drop-shadow(0 15px 25px rgba(0,0,0,0.6))',
          pointerEvents: 'none',
        }}
      />
    </div>
  </section>

  {/* Mobile Landing Section */}
<section id="mobile-landing" className="mobile-landing">
  <style>
    {`
     
      @media (min-width: 768px) {
        .mobile-landing { display: none; }
        .desktop-landing { display: block; }
      }

      @media (max-width: 768px) {
        .mobile-landing {
          display: block;
          position: relative;
          width: 100%;
          min-height: 100svh;
          height: 100svh;
          padding-top: 72px;
          background-color: #0b1420;
          overflow: hidden;
          font-family: 'Alphakind', sans-serif;
        }

        .desktop-landing { display: none; }

        .mobile-landing::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: url("${mobileHeroBg}");
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          filter: none;
          z-index: 0;
        }

          /* Overlays removed for pure image visibility */

        .hero-text-mobile {
          position: absolute;
          top: 19%;
          left: 6%;
          transform: translate(0, -50%);
          text-align: left;
          color: #000;
          z-index: 2;
          width: 90%;
        }

        .hero-text-mobile h1 {
          font-size: 2.55rem;
          font-weight: 900;
          margin-bottom: 0.55rem;
          letter-spacing: 2px;
          line-height: 0.96;
          white-space: nowrap;
        }

        .hero-text-mobile h4 {
          font-size: 1.28rem;
          font-weight: 800;
          margin-bottom: 0.8rem;
          letter-spacing: 1.2px;
          line-height: 1.2;
        }

        .typed-mobile {
          font-size: 1.58rem;
          font-weight: 1000;
          letter-spacing: 2.4px; 
          text-shadow:
            0 0 10px rgba(245, 215, 119, 0.28),
            0 0 18px rgba(212, 164, 58, 0.18);
        }

        .center-card {
          position: absolute;
          top: 56%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 42%;
          border-radius: 1rem;
          overflow: hidden;
          z-index: 3;
          border: 2px solid rgba(212, 164, 58, 0.78);
          box-shadow:
            0 8px 16px rgba(0, 0, 0, 0.5),
            0 0 18px rgba(212, 164, 58, 0.16),
            inset 0 0 0 1px rgba(245, 215, 119, 0.12);
        }

        .center-card img {
          width: 100%;
          display: block;
        }
      }
    `}
  </style>

  {/* Hero Text in Red Section */}
  <motion.div
  className="hero-text-mobile"
  initial={{ x: -100, opacity: 0 }}
  animate={{ x: 0, opacity: 1 }}
  transition={{ delay: 0.2, duration: 0.9 }}
>
  <h1 className="arcane-gold" style={{ fontFamily: "'Cinzel Decorative', serif", letterSpacing: '4px' }}>ROBOCOR '26</h1>
  <h4 className="arcane-gold">
    <span style={{ fontSize: '1em', fontWeight: 'inherit' }}>"</span>
    In Steel we Forge, In Hex we Rise.
    <span style={{ fontSize: '1em', fontWeight: 'inherit' }}>"</span>
  </h4>

  <div className="typed-mobile hero-date-wrap">
    <ReactTyped
      strings={["April 16th"]}
      typeSpeed={80}
      backSpeed={40}
      loop
      className="hero-date-text"
    />
  </div>

  
</motion.div>

  

  {/* Centered Character Image Across Red/Black Border */}
  <div className="center-card">
    <img src={characterImg} alt="Hero" />
  </div>
  <div className="countdown-mobile">
  <CountDownTimer
    targetDate={new Date("2026-04-16T00:00:00")}
  />
</div>

 
</section>

</div>




      {/* Events Cards Section */}
      <section
       id="events"
        className={`content-section container-fluid py-5 ${isScrolled ? "fade-in" : ""}`}
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${eventsBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          color: 'white',
          padding: '480px 0 100px',
        }}>
        <div className="container">
  {/* Overlayed Cyberpunk City Image */}
 
     <h1 className="section-title arcane-gold">Our Events</h1>



        <div className="row g-4 cyber-container">
  {[
    {
      title: "Binary Runes",
      img:"https://res.cloudinary.com/dfli7mciv/image/upload/v1747151250/bytewars_kuvbgk.jpg",
      about: "Competitive coding battle for sharp minds.",
      date: "10:30 AM",
      venue: "Chemical Seminar Hall",
      route: "/register/binaryduels"
    },
    {
      title: "Hex Track",
      img: "https://res.cloudinary.com/dfli7mciv/image/upload/v1747151257/droidrace_dojqd3.jpg",
      about: "Race your innovation, follow the line, and conquer the track!",
      date: "10:30 AM",
      venue: "Indoor Stadium",
      route: "/register/cybertrack"
    },
    {
      title: "Construct Clash",
      img:"https://res.cloudinary.com/dfli7mciv/image/upload/v1747151256/droidkick_clmrpl.jpg",
      about: "Kick, score, and rule the field with your robotic soccer skills!",
      date: "10:30 AM",
      venue: "AICTE Lab Basement",
      route: "/register/cyberkick"
    },
    {
      title: "Project Nexus",
      img:"https://res.cloudinary.com/dfli7mciv/image/upload/v1747151974/WhatsApp_Image_2025-05-13_at_8.53.51_PM_uhxjfo.jpg",
      about: "Showcase your brilliance, innovate, and lead the future at Project Nexus!",
      date: "10:30 AM",
      venue: "Faraday seminar hall",
      route: "/register/projectconclave"
    },
    {
      title: "Arcane Quiz",
      img:"https://res.cloudinary.com/dfli7mciv/image/upload/v1747151258/quiz_xsdgoh.jpg",
      about: "Test your knowledge, challenge your mind, and emerge as the ultimate quiz champion!",
      date: "12:45 PM",
      venue: "Online",
      route: "/register/nexusquiz"
    },
    {
      title: "Zaun Race",
      img:"https://res.cloudinary.com/dfli7mciv/image/upload/v1747151259/starcrawl_jixzio.jpg",
      about: "Conquer the toughest terrains, endure the rugged race, and emerge victorious!",
      date: "10:30 AM",
      venue: "Outdoor Stadium",
      route: "/register/neonrun"
    },
    {
      title: "Runic Maze",
      img:"https://res.cloudinary.com/dfli7mciv/image/upload/v1747151259/starlink_pxek8d.jpg",
      about: "Navigate the glow, command with Bluetooth, and master the Runic Maze!",
      date: "10:30 AM",
      venue: "AICTE Lab Basement",
      route: "/register/neonmaze"
    },
    {
      title: "Arduino Alchemy",
      img:"https://res.cloudinary.com/dfli7mciv/image/upload/v1747151259/projectSymposium_o3xtwd.jpg",
      about: "Debug, design, and dominate the circuit at Arduino Alchemy!",
      date: "10:30 AM",
      venue: "TEL 101",
      route: "/register/arduinoforge"
    },
    {
      title: "BGMI Rush",
      img:"https://res.cloudinary.com/dfli7mciv/image/upload/v1747151972/WhatsApp_Image_2025-05-13_at_8.09.37_PM_k7kotp.jpg",
      about: "Drop in, gear up, and battle your way to glory in BGMI Rush!",
      date: "10:30 AM",
      venue: "Online",
      route: "/register/bgmipunks"
    }
  ].map((event, index, events) => (
    <div
      key={index}
      className={`col-lg-6 col-md-6 col-12 d-flex justify-content-center${
        events.length % 2 === 1 && index === events.length - 1 ? " mx-auto" : ""
      }`}
    >
      <div className="cyber-card-custom" style={{ width: '100%', maxWidth: '350px' }}>
        {/* Golden Frame Overlay */}
        <img
          src={cardFrame}
          alt=""
          className="card-frame-overlay"
        />
        <img
          src={event.img}
          alt={event.title}
          className="cyber-img"
          style={{ position: 'relative', zIndex: 3 }}
        />
        <div className="cyber-card-body" style={{ position: 'relative', zIndex: 3 }}>
          <h5 className="neon-title">{event.title}</h5>
          <p>{event.about}</p>
         <p className="event-info"><strong>Time -</strong> {event.date}</p>
         <p className="event-info"><strong>Venue -</strong> {event.venue}</p>

          <Link to={event.route} className="cyber-button">Register</Link>

        </div>
      </div>
    </div>
  ))}
</div>
</div>
</section>
     
{/* About ROBOCOR Section */}
<section
  id="about"
  className="content-section container-fluid py-5"
  style={{
    background: 'black',
    color: '#d4a43a',
    padding: '40px',
    fontFamily: "'Alphakind', sans-serif"

  }}
>
  <div className="container">
   <h1 className="section-title arcane-gold">About ROBOCOR</h1>

    <div className="row align-items-center">
      <div className="col-md-6 mb-4 mb-md-0">
        <img
  src={image1}
  alt="ROBOCOR Robotics Competition"
  className="img-fluid rounded shadow"
  style={{
    borderRadius: '0.375rem',
    border: '2px solid rgba(212, 164, 58, 0.75)',
    boxShadow: '0 0 24px rgba(212, 164, 58, 0.16), 0 10px 28px rgba(0, 0, 0, 0.35)'
  }}
/>

      </div>
      <div className="col-md-6">
        <p className="lead text-justify" style={{ fontSize: "1.2rem", lineHeight: "1.8", color: '#ffffff' }}>
          <strong>ROBOCOR</strong>, one of Karnataka's premier robotics competitions, is a nationally renowned event that brings together innovative minds from across the country.
          It serves as a platform for participants to showcase their creativity, technical expertise, and problem-solving skills while competing for glory.
  
        </p>
      </div>
    </div>
  </div>
</section>
{/* Sponsors Section - Carousel Style */}
<section
  id="sponsors"
  className="content-section container-fluid py-5"
  style={{
    background: 'black',
    color: '#d4a43a',
    padding: '40px',
    fontFamily: "'Alphakind', sans-serif"
  }}
>
  <div className="container text-center">
    <h1 className="section-title arcane-gold">Our Sponsors</h1>
    <Slider
  dots={true}
  infinite={true}
  speed={500}
  slidesToShow={3}
  slidesToScroll={1}
  autoplay={true}
  autoplaySpeed={2000}
  responsive={[
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ]}
>
  {[sponsor1, sponsor2, sponsor3].map((sponsor, index) => (
    <div key={index} className="px-3">
      <div 
        className="p-3 rounded shadow sponsor-carousel-card d-flex align-items-center justify-content-center"
        style={{ height: '180px', backgroundColor: '#111', border: '1px solid #333' }}
      >
        <img
          src={sponsor}
          alt={`Sponsor ${index + 1}`}
          className="img-fluid"
          style={{
            maxHeight: "140px",
            maxWidth: "100%",
            objectFit: "contain",
          }}
        />
      </div>
    </div>
  ))}
</Slider>

  </div>
</section>
</div>
  );
};

export default Landing;
